import BaseScreen from './_base';

export default function ConfigurationsScreen() {
  return <BaseScreen title="Configurations" description="Account preferences and settings." />;
}
